import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ObservableBackendService} from './observableBackend.service';
import {Rol} from '../domain/rol';
import {ActionAllowed} from '../domain/actionAllowed';
import {URLSearchParams} from "@angular/http";
import {Page} from "../domain/page";

@Injectable()
export class RolesService {

    constructor(private backendService:ObservableBackendService) {
    }

    public findRoles(filter:string, page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        if (filter) {
            params.set('name', filter);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("roles", params);
    }

    public getRol(rolId:string):Observable<Rol> {
        return this.backendService.get("rol/" + rolId, null);
    }

    public getNewRol():Observable<Rol> {
        return this.backendService.get("rol/new", null);
    }

    public getRoles():Observable<Rol[]> {
        return this.backendService.get("listRoles/", null);
    }

    public save(rol:Rol):Observable<Rol> {
        return rol.id != null
            ? this.backendService.post("rol", rol, null)
            : this.backendService.put("rol", rol, null);
    }

    public delete(rolId:string):Observable<Rol> {
        return this.backendService.delete("rol/" + rolId, null, null);
    }

    public getActionsAllowed(appSection:string):Observable<ActionAllowed[]> {
        return this.backendService.get("rol/actionsAllowed/" + appSection, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/roles.service.ts
 **/